<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span i18n='Club section title@@clubOverviewComponent.sectionHeading.personalization' class="esf-action-heading__text">Personalization</span>
</h4>
<div class="esf-info-tile" style="flex: 1;">
  <div class="esf-info-tile__content">
    <div class="esf-grid">
      <hr style="width: 100%; padding: 5px 0px; border: none;" [style.background]="currentColor" />
    </div>

    <div class="esf-grid">
      <div *ngIf="!selectedClub.pathToLogo" class="temporary-box"></div>
      <img *ngIf="selectedClub.pathToLogo" class="club-logo" src="{{ selectedClub.pathToLogo }}" alt="Club logo">
    </div>

    <div class="esf-submit-row">
      <div class="esf-submit-row__item">
        <button class="esf-button esf-button--simple"
                [(colorPicker)]="color" [cpSaveClickOutside]="false"
                [cpOKButton]="true" [cpOKButtonText]="'Submit'" [cpOKButtonClass]="'esf-button esf-button--standard esf-button--filled'"
                [cpCancelButton]="true" [cpCancelButtonText]="'Close'" [cpCancelButtonClass]="'esf-button esf-button--standard esf-button--outlined'"
                [cpOutputFormat]="'hex'" [cpPosition]="'bottom'"
                (colorPickerSelect)="changeColorValue(color)">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-color"></use>
          </svg>
          <span class="esf-button__icon-text" i18n='Action button@@clubOverview.button.changeColor'>Change color</span>
        </button>
      </div>
      <div class="esf-submit-row__item">
        <button class="esf-button esf-button--simple" (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.togleEditLogoModal(true)"
                [disabled]="!(authenticatedUser.permissions.club.add)">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-image"></use>
          </svg>
          <span class="esf-button__icon-text" i18n='Action button@@clubOverview.button.uploadLogo'>Upload Logo</span>
        </button>
      </div>
    </div>
  </div>
</div>
